import { ViewportScroller } from '@angular/common';
import {
  Component,
  computed,
  inject
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { DrawerService } from '../drawer/drawer.service';
import { HoverGradientDirective } from '../shared/directives/hover-gradient.directive';
import { AuthService } from '../shared/services/auth.service';
import { AccountSpaBookingComponent } from './account-spa-booking/account-spa-booking.component';
import { CreditsComponent } from './credits/credits.component';
import { NextAppointmentComponent } from './next-appointment/next-appointment.component';
import { OrdersComponent } from './orders/orders.component';
import { ProfileComponent } from './profile/profile.component';
import { VitalityPlanningComponent } from './vitality-planning/vitality-planning';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  imports: [
    ProfileComponent,
    CreditsComponent,
    NextAppointmentComponent,
    OrdersComponent,
    NgxTolgeeModule,
    AccountSpaBookingComponent,
    HoverGradientDirective
  ]
})
export class AccountComponent {
  authService = inject(AuthService);
  drawerService = inject(DrawerService);
  viewportScroller = inject(ViewportScroller);
  displayName = computed(() => {
    const user = this.authService.user();
    if (user?.firstName || user?.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    return user?.email ?? '--';
  });

  displayPlanning(): void {
    this.drawerService.open({
      component: VitalityPlanningComponent,
      inputs: { mode: 'plan' },
      style: 'white',
      title: 'vitalityPlanningTitle'
    })
  }
}
